import ApplianceRender from "../ApplianceRender";

const SainiSomay = () => {
    return (
        <ApplianceRender roomName={"SainiSomay"}/>
    )
}

export default SainiSomay